import { PageTab } from 'component/PageTabs'
import { VideoTypeEnum } from 'constant/common'
import React, { useMemo } from 'react'

export const SEARCH_TYPE_ID: Record<string, number> = {
  video: VideoTypeEnum.LongVideo,
  short: VideoTypeEnum.ShortVideo,
  comic: VideoTypeEnum.Comic,
}

export const SEARCH_TYPE_TABS: Array<{ id: string; name: string }> = [
  {
    id: 'video',
    name: '长视频',
  },
  {
    id: 'short',
    name: '短视频',
  },
  {
    id: 'comic',
    name: '漫画',
  },
]

interface ContentComponents {
  video?: React.ComponentType
  short?: React.ComponentType
  comic?: React.ComponentType
}

interface ContentTabParams {
  filter?: number[]
  [key: string]: any
}

export const useContentTab = (components: ContentComponents = {}, params: ContentTabParams = {}) => {
  const searchTypes = useMemo(() => {
    // FIXED list specifics for ald88
    const list = [SEARCH_TYPE_ID.video]
    if (Array.isArray(params.filter)) return list.filter((m) => params.filter!.includes(m))
    return list
  }, [params])
  const tabs = useMemo(() => SEARCH_TYPE_TABS.filter((i) => searchTypes.includes(SEARCH_TYPE_ID[i.id])), [searchTypes])

  const hasVideo = useMemo(() => {
    return searchTypes.findIndex((m) => m === SEARCH_TYPE_ID.video) >= 0
  }, [searchTypes])

  const hasShort = useMemo(() => {
    return searchTypes.findIndex((m) => m === SEARCH_TYPE_ID.short) >= 0
  }, [searchTypes])

  const hasComic = useMemo(() => {
    return searchTypes.findIndex((m) => m === SEARCH_TYPE_ID.comic) >= 0
  }, [searchTypes])

  const hasNovel = false

  const tabContents = useMemo(() => {
    if (!components) return <></>
    return (
      <>
        {components.video && hasVideo && (
          <PageTab>
            <components.video />
          </PageTab>
        )}
        {components.short && hasShort && (
          <PageTab>
            <components.short />
          </PageTab>
        )}
        {components.comic && hasComic && (
          <PageTab>
            <components.comic />
          </PageTab>
        )}
      </>
    )
  }, [components, hasComic, hasShort, hasVideo])

  return { tabs, hasVideo, hasShort, hasComic, hasNovel, tabContents }
}
